import { Alert, Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { ComponentType } from 'react';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import {
  type AnalysisResultType,
  hasAnalysisViews,
} from '@/lib/jobs/analysisViews';
import HydraDataQCTab from '../../../../../../pages/experiments/resultsAnalysis/hydra/HydraDataQCTab';
import IdDataQCTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdDataQCTab';
import IdParquetDataQCTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdParquetDataQCTab';
import MwmineFeaturesDataQCTab from '../../../../../../pages/experiments/resultsAnalysis/mwmineFeatures/MwmineFeaturesDataQCTab';
import PeptidesDataQCTab from '../../../../../../pages/experiments/resultsAnalysis/peptides/PeptidesDataQCTab';
import QuantDataQCTab from '../../../../../../pages/experiments/resultsAnalysis/quant/QuantDataQCTab';

const DATA_QC_TABS: Record<AnalysisResultType, ComponentType> = {
  QUANT: QuantDataQCTab,
  ID: IdDataQCTab,
  ID_PARQUET: IdParquetDataQCTab,
  HYDRA: HydraDataQCTab,
  PEPTIDES: PeptidesDataQCTab,
  MWMINE_FEATURES: MwmineFeaturesDataQCTab,
};

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/data-qc'
)({
  staticData: { ddViewName: 'experiments-data-qc-tab' },
  component: DataQCRouteComponent,
});

function DataQCRouteComponent() {
  const { selectedJob, selectedJobId, jobs } = useSampleSet();

  const showAlert = !selectedJobId && jobs.length > 0;

  // The layout sends the user to Samples when the run has no analysis views.
  const resultType = selectedJob?.result_type;
  const DataQCTab = hasAnalysisViews(resultType)
    ? DATA_QC_TABS[resultType]
    : null;

  return (
    <>
      {showAlert && (
        <Box sx={{ mx: 2, mt: 1 }}>
          <Alert severity="info" sx={{ mb: 1 }}>
            Please select an inference run to view data QC results
          </Alert>
        </Box>
      )}
      {DataQCTab && <DataQCTab />}
    </>
  );
}
